var map = {
	"./bland.png": 260,
	"./cali.png": 492,
	"./carni.png": 148,
	"./fibertracker.png": 747,
	"./fodmap.png": 262,
	"./glp1tracker.png": 793,
	"./graceanchor.png": 882,
	"./ifa.png": 63,
	"./life.png": 163,
	"./med.png": 919,
	"./nasaliq.png": 850,
	"./origami.png": 663,
	"./pcos.png": 488,
	"./pilates.png": 129,
	"./rice.png": 654,
	"./snakeid.png": 446,
	"./subkill.png": 443,
	"./vitala.png": 414,
	"./yellow-teeth.png": 792
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 796;